import { sharedExtensionCards } from '../gameData/extensions.shared';
import { SimplifiedExtensionCard } from '../types/ExtensionCard';

export const getVisibleExtensions = <T extends SimplifiedExtensionCard>(
  extensions: T[],
  applyFilter: boolean = true,
): T[] => {
  if (!applyFilter) {
    return extensions;
  }
  return extensions.filter((extension) => {
    return (
      !sharedExtensionCards[extension.type].isHidden || extension.wasDisclosed
    );
  });
};
